import Vue from 'vue'

const state = () => {
  return {
    list: []
  }
}

const getters = {}

const mutations = {
  SET_ACTIVITIES(state, activities) {
    state.list = [...activities]
  },
  ADD_ACTIVITY(state, activity) {
    if (state.list.findIndex((a) => a._id === activity._id) === -1) {
      state.list.push(activity)
    }
  },
  ADD_REPLY(state, activity) {
    const activityIndex = state.list.findIndex((a) => a._id === activity.inReplyTo)
    if (activityIndex > -1) {
      if (state.list[activityIndex].replies.findIndex((r) => r._id === activity._id) === -1) {
        state.list[activityIndex].replies.push(activity)
      }
    }
  }
}

const actions = {
  async getActivities({ commit }, slug) {
    try {
      let { data } = await Vue.axios.get(`feature/${slug}/activities`)
      commit('SET_ACTIVITIES', data)
    } catch (error) {}
  },

  async postComment({ rootState, commit }, comment) {
    try {
      const slug = rootState.features.selected.slug
      let { data } = await Vue.axios.post(`feature/${slug}/action/comment`, comment)
      data.type = 'comment'
      console.log('comment', comment, data)
      if (comment.inReplyTo) {
        commit('ADD_REPLY', data)
      } else {
        commit('ADD_ACTIVITY', data)
      }
    } catch (error) {}
  },

  postCommentReceived({ commit }, event) {
      const { activity } = event
      if (activity.inReplyTo) {
        commit('ADD_REPLY', activity)
      } else {
        commit('ADD_ACTIVITY', activity)
      }
  },

  addStatusUpdate({ commit, rootState }, activity) {
    let user = rootState.user
    user.fullName = `${user.firstName} ${user.lastName}`
    commit('ADD_ACTIVITY', { ...activity, user })
  },

  addStatusUpdateReceived({ commit, rootState }, event) {
    const { features } = rootState
    const { activity, user, feature } = event
    if (features && features.selected && features.selected._id === feature._id) {
      commit('ADD_ACTIVITY', { ...activity, user })
    }
  },

  addAssignUpdate({ commit, rootState }, result) {
    let user = rootState.user
    user.fullName = `${user.firstName} ${user.lastName}`
    commit('ADD_ACTIVITY', { ...result, user })
  },

  addAssignUpdateReceived({ commit, rootState }, event) {
    const { features } = rootState
    const { activity, user, feature } = event
    if (features && features.selected && features.selected._id === feature._id) {
      commit('ADD_ACTIVITY', { ...activity, user })
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
